module.exports = __webpack_public_path__ + "img/COMBO FLOWER GREEN.6712b2f.svg";